import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem4 = ({ branch = "AIDS" }) => {
  const notes = [
    { title: 'Object Oriented Programming', link: `/notes/${branch.toLowerCase()}/OOPS` },
    { title: 'Database Management System', link: `/notes/${branch.toLowerCase()}/DBMS` },
    { title: 'Software Engineering', link: `/notes/${branch.toLowerCase()}/SE` },
    { title: 'Computer Networks and Internet Protocol', link: `/notes/${branch.toLowerCase()}/CN` },
    { title: 'Fundamentals of Machine Learning', link: `/notes/${branch.toLowerCase()}/ML` },
    { title: 'Computational Methods', link: `/notes/${branch.toLowerCase()}/CM` },
    { title: 'Effective Technical Writing', link: `/notes/${branch.toLowerCase()}/ETW` }
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="4th Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem4;
